import { createLazyComponent } from '@muse-web/router'

export const AsyncPurchaseSuccessDialogContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'dialog-checkout' */ './PurchaseSuccessDialogContainer'),
    'PurchaseSuccessDialogContainer',
)
